"use client";

import React from "react";
import { SidebarMenuButton } from "@/components/ui/sidebar";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronRight } from "lucide-react";

interface Props {
  children: React.ReactNode;
  slug: string;
  variant?: "default" | "outline";
  size?: "default" | "sm" | "lg";
}

export function WorkspaceSidebarMenuLink({ children, slug, variant, size }: Props) {
  const pathname = usePathname();
  const isActive = pathname.includes(slug);

  return (
    <SidebarMenuButton asChild size={size} variant={variant} isActive={isActive}>
      <Link href={slug}>
        {children}
        <ChevronRight className="size-4 ml-auto opacity-50" />
      </Link>
    </SidebarMenuButton>
  );
}
